import { EventType } from "../../enum/EventType";
import { Protection } from "./Protection";
import { Weapon } from "./Weapon";
import { Position } from "./Position";
import { Player } from "./Player";

export class Event{
    public timestamp : string;
    public type : EventType;
    public internalMissionId  : string;
    public sourcePath? : string;
    public durationMillis : number;
    public lacsMissionId? : string;
    public missionStatus? : string;
    public isKilled? : boolean;
    public kitId? : string;
    public sourceId? : string;
    public hitZone? : string;
    public kitStatus? : string;
    public ammoType? : string;
    public hits? : number;
    public batteryLevel? : number;
    public booisKilled? : boolean;
    public protections? : Protection[];
    public position? : Position;
    public weapons? : Weapon[];
    public players? : Player[];

    constructor(timestamp: string, type: EventType, internalMissionId: string, durationMillis: number){
        this.timestamp=timestamp;
        this.type=type;
        this.internalMissionId=internalMissionId;
        this.durationMillis=durationMillis;
    }
}